<style lang="stylus">
    .focus-tool-layercontainer
        background var(--bg-color-tertiary)
        padding-bottom 8px
        border-bottom-left-radius 5px
        border-bottom-right-radius 5px
        width 180px
        .blockItem-btnBox
            display flex
            align-items center
            padding 3px 0
            justify-content space-around
            border-bottom 1px solid $box-bordercolor-lignt
            flex-wrap wrap
            &:last-child
                border-bottom unset
            .activeFunc
                background-color var(--themeActived)
            li
                position relative
                width 32px
                height 32px
                margin 0 4px
                display block
                flex-shrink 1
                list-style none
                text-align center
                line-height 32px
                border-radius $common-border-radius

                &:not(.activeFunc):hover
                    background-color $main-hovercolor
                &.navigation-ban-btn:hover
                    .item-icon
                        cursor not-allowed
                .item-icon
                    width 20px
                    height 20px
                    margin-top 6px
                    margin-bottom 6px
                    color var(--svg-color-gray-42)

                &:nth-child(n+5)
                    margin-top 6px

            li.active
                background-color $main-selectcolor
</style>

<template>
    <DragBox
        :dragTitle="dragTitle"
        :originPostion="{ left: `${originPostion.left}px`, top: `${originPostion.top}px` }"
        :style="{ left: `${originPostion.left}px`, top: `${originPostion.top}px` }"
        :showModal="showModal"
        :lockBox="lockBox"
        @changeLock="changeLock($event)"
        @updateBoxPos="updateBoxPos($event)"
        @removeCloseEvent="removeCloseListener()"
        @closeBox="closeEvent()"
    >
        <div class="focus-tool-layercontainer">
            <ul class="blockItem-btnBox">
                <li
                    v-for="item in layerList"
                    :key="item.id"
                    :content="$t(`tipsList.${item.name}`)"
                    v-tippy="{ placement: 'bottom' }"
                    @click="setLayerByIndex(item.id)"
                >
                    <iconSymbol class="item-icon" :name="item.name"></iconSymbol>
                </li>
            </ul>
        </div>
    </DragBox>
</template>

<script lang="ts">
    import { Component, Prop, Vue } from "vue-property-decorator";
    import DragBox from "../Tabs/NavigationDragBox.vue";

    @Component({
        components: {
            DragBox,
        },
    })
    export default class FocusExpandToolLayer extends Vue {
        @Prop()
        index;
        @Prop()
        dragTitle;
        @Prop()
        showModal;
        @Prop()
        originPostion;
        @Prop()
        lockBox;

        layerList: Array<object> = [
            {
                id: 0,
                text: "",
                name: "layer1",
                func: "tabsMoveTop",
            },
            {
                id: 1,
                text: "",
                name: "layer2",
                func: "tabsMoveBottom",
            },
            {
                id: 2,
                text: "",
                name: "layer3",
                func: "tabsMoveUp",
            },
            {
                id: 3,
                text: "",
                name: "layer4",
                func: "tabsMoveDown",
            },
        ];
        updateBoxPos(pos) {
            this.$emit("updateBoxPos", pos);
        }

        setLayerByIndex(index) {
            window["_view"].orderShape(index);
        }

        changeLock(e) {
            e && this.$emit("changeLock", this.index);
        }
        removeCloseListener() {
            this.$emit("removeCloseEvent", this.index);
        }
        closeEvent() {
            this.$emit("closeBox", this.index);
        }

        mounted() {}

        created() {}
    }
</script>
<i18n>
{
  "zh": {
    "tipsList": {
      "toggleLib": "显示符号库",
      "undo": "撤销",
      "redo": "重做",
      "format": "格式刷",
      "text": "添加文本   Ctrl+2",
      "textAlign": "布局、对齐、等宽高",
      "layout": "位置、宽高、角度",
      "fixRatio": "锁定纵横比",
      "layer": "层级",
      "fillColor": "填充颜色",
      "lineColor": "线条颜色",
      "compose": "组合",
      "search": "查找",
      "protect": "锁定",
      "option": "特殊设置",
      "acquiesceStyle": "线条样式",
      "theme": "快速样式",
      "connector": "连接线",
      "layer1": "移至顶部",
      "layer2": "移至底部",
      "layer3": "上移一层",
      "layer4": "下移一层",
      "align01": "左对齐",
      "align02": "居中对齐",
      "align03": "右对齐",
      "align04": "顶部对齐",
      "align05": "居中对齐",
      "align06": "底部对齐",
      "align07": "水平等间距",
      "align08": "垂直等间距",
      "sameWidth": "等宽",
      "sameHeight": "等高",
      "sameAngle": "等角度",
      "sameSize": "等大小",
      "replace": "替换",
      "replaceAll": "替换全部",
      "styleBrush": "格式刷",
      "leftArrow": "起点",
      "rightArrow": "终点"
    }
  },
  "en": {
    "tipsList": {
      "toggleLib": "Show Symbol Library",
      "undo": "Undo",
      "redo": "Redo",
      "format": "Format Painter",
      "text": "Add Text Ctrl+2",
      "textAlign": "Layout, Alignment, Aspect Ratio",
      "layout": "Position, Width, Height, Angle",
      "fixRatio": "Lock aspect ratio",
      "layer": "Layer",
      "fillColor": "Fill Color",
      "lineColor": "Line Color",
      "compose": "Group",
      "search": "Find",
      "protect": "Locked",
      "option": "Exceptional Settings",
      "acquiesceStyle": "Line Style",
      "theme": "Quick Style",
      "connector": "Connector",
      "layer1": "Bring to Front",
      "layer2": "Send to Back",
      "layer3": "Bring forward",
      "layer4": "Send backward",
      "align01": "Align Left",
      "align02": "Align Center",
      "align03": "Align Right",
      "align04": "Align Top ",
      "align05": "Align Middle ",
      "align06": "Align Bottom ",
      "align07": "Distribute Horizontally",
      "align08": "Distribute Vertically",
      "sameWidth": "Same Width",
      "sameHeight": "Same Height",
      "sameAngle": "Same Angle",
      "sameSize": "Same Size",
      "replace": "Replace",
      "replaceAll": "Replace All",
      "styleBrush": "Format Painter",
      "leftArrow": "Start",
      "rightArrow": "End"
    }
  },
  "fr": {
    "tipsList": {
      "toggleLib": "Afficher Bibliothèque de Symboles",
      "undo": "Annuler",
      "redo": "Refaire",
      "format": "Format Brosse",
      "text": "Texte",
      "textAlign": "Alignement",
      "layout": "Attribut",
      "fixRatio": "Verrouiller le rapport hauteur / largeur",
      "layer": "Niveau",
      "fillColor": "Couleur de remplissage",
      "lineColor": "Couleur du trait",
      "compose": "Combinaison",
      "search": "Rechercher",
      "protect": "Protéger",
      "option": "Paramètres spéciaux",
      "acquiesceStyle": "Style de ligne",
      "theme": "Style rapide",
      "connector": "Ligne de connexion",
      "layer1": "Déplacer vers haut",
      "layer2": "Déplacer vers bas",
      "layer3": "Avancer",
      "layer4": "Reculer",
      "align01": "Aligner à gauche",
      "align02": "Aligner au centre",
      "align03": "Aligner à Droit",
      "align04": "Aligner en haut",
      "align05": "Aligner au centre",
      "align06": "Aligner en bas ",
      "align07": "À égale distance horizontale",
      "align08": "À égale distance verticale",
      "sameWidth": "Même largeur",
      "sameHeight": "Même hauteur ",
      "sameAngle": "Même angle",
      "sameSize": "Même angle",
      "replace": "Remplacer",
      "replaceAll": "Tout remplacer ",
      "styleBrush": "Pinceau de format",
      "leftArrow": "Début",
      "rightArrow": "Fin"
    }
  },
  "de": {
    "tipsList": {
      "toggleLib": "Symbol Bibliothek anzeigen",
      "undo": "Rückgängig machen",
      "redo": "Wiederherstellen",
      "format": "Format",
      "text": "Text",
      "textAlign": "Ausrichten",
      "layout": "Eigenschaft",
      "fixRatio": "Seitenverhältnis sperren",
      "layer": "Ebene",
      "fillColor": "Farbe eingeben",
      "lineColor": "Liniensfarbe",
      "compose": "Gruppieren",
      "search": "Suchen",
      "protect": "Schützen",
      "option": "Ausserordentliche Einstellungen",
      "acquiesceStyle": "Linien Style",
      "theme": "Quick Style",
      "connector": "Verbindung",
      "layer1": "In den Vordergrund",
      "layer2": "In den Hintergrund",
      "layer3": "Ebene nach vorne",
      "layer4": "Ebene nach hinten",
      "align01": "Linksbündig",
      "align02": "Zentriert ",
      "align03": "Rechtsbündig",
      "align04": "Obenbündig",
      "align05": "Mittebündig",
      "align06": "untenbündig",
      "align07": "Horizontaler Abstand",
      "align08": "Vertikaler Abstand",
      "sameWidth": "Gleiche Breite",
      "sameHeight": "Gleiche Höhe",
      "sameAngle": "Gleicher Winkel",
      "sameSize": "Gleiche Größe",
      "replace": "Ersetzen",
      "replaceAll": "Alles ersetzen",
      "styleBrush": "Stil Pinsel",
      "leftArrow": "Startpunkt",
      "rightArrow": "Endpunkt"
    }
  },
  "jp": {
    "tipsList": {
      "toggleLib": "図形ライブラリを表示",
      "undo": "元に戻す",
      "redo": "やり直し",
      "format": "書式のコピーと貼り付け",
      "text": "テキスト",
      "textAlign": "テキストの揃え方",
      "layout": "レイアウト",
      "fixRatio": "アスペクト比のロック",
      "layer": "レベル",
      "fillColor": "塗りつぶし",
      "lineColor": "線の色",
      "compose": "グループ化",
      "search": "検索",
      "protect": "ロック",
      "option": "特別な設定",
      "acquiesceStyle": "線のスタイル",
      "theme": "クイック書式",
      "connector": "コネクター",
      "layer1": "最前面へ移動",
      "layer2": "最背面へ移動",
      "layer3": "前面へ移動",
      "layer4": "背面へ移動",
      "align01": "左揃え",
      "align02": "中央揃え",
      "align03": "右揃え",
      "align04": "上揃え",
      "align05": "中央揃え",
      "align06": "下揃え",
      "align07": "水平方向等間隔",
      "align08": "垂直方向等間隔",
      "sameWidth": "等幅",
      "sameHeight": "等高",
      "sameAngle": "等角",
      "sameSize": "等サイズ",
      "replace": "置換",
      "replaceAll": "すべてを置換",
      "styleBrush": "書式のコピー／貼り付け",
      "leftArrow": "出発点",
      "rightArrow": "終点"
    }
  },
  "es": {
    "tipsList": {
      "toggleLib": "Mostrar Biblioteca de símbolos",
      "undo": "Deshacer",
      "redo": "Rehacer",
      "format": "Pintor de Formatos",
      "text": "Añadir texto Ctrl+2",
      "textAlign": "Disposición, alineación, relación de aspecto",
      "layout": "Posición, anchura, altura, ángulo",
      "fixRatio": "Bloquee la relación de aspecto",
      "layer": "Capa",
      "fillColor": "Color de relleno",
      "lineColor": "Color de línea",
      "compose": "Grupo",
      "search": "Encuentra",
      "protect": "Proteger",
      "option": "Ajustes excepcionales",
      "acquiesceStyle": "Estilo de línea",
      "theme": "Estilo rápido",
      "connector": "Conector",
      "layer1": "Traer al frente",
      "layer2": "Enviar a la parte de atrás",
      "layer3": "Traer al frente",
      "layer4": "Enviar hacia atrás",
      "align01": "Alinear a la izquierda",
      "align02": "Alinear el centro",
      "align03": "Alinear a la derecha",
      "align04": "Alinear la parte superior ",
      "align05": "Alinear el medio ",
      "align06": "Alinear el fondo ",
      "align07": "Distribuir horizontalmente",
      "align08": "Distribuir verticalmente",
      "sameWidth": "Mismo ancho",
      "sameHeight": "Misma altura",
      "sameAngle": "Mismo ángulo",
      "sameSize": "Mismo tamaño",
      "replace": "Reemplazar",
      "replaceAll": "Reemplazar todo",
      "styleBrush": "Pincel de formato",
      "leftArrow": "Punto de partida",
      "rightArrow": "Punto final"
    }
  },
  "pt": {
    "tipsList": {
      "toggleLib": "Mostrar Biblioteca de Símbolo",
      "undo": "Desfazer",
      "redo": "Refazer",
      "format": "Formatar Pintor",
      "text": "Adicionar Texto Ctrl+2",
      "textAlign": "Layout, Alinhamento, Relação de Aspecto",
      "layout": "Posição, Largura, Altura, Ângulo",
      "fixRatio": "Bloquear relação de aspecto",
      "layer": "Camada",
      "fillColor": "Preencher Cor",
      "lineColor": "Cor da Linha",
      "compose": "Agrupar",
      "search": "Encontrar",
      "protect": "Bloqueado",
      "option": "Configurações Excepcionais",
      "acquiesceStyle": "Estilo da Linha",
      "theme": "Estilo Rápido",
      "connector": "Conector",
      "layer1": "Trazer para a Frente",
      "layer2": "Enviar para Trás",
      "layer3": "Avançar",
      "layer4": "Retroceder",
      "align01": "Alinhar à Esquerda",
      "align02": "Alinhar ao Centro",
      "align03": "Alinhar à Direita",
      "align04": "Alinhar em Cima",
      "align05": "Alinhar ao Meio",
      "align06": "Alinhar em Baixo",
      "align07": "Distribuir Horizontalmente",
      "align08": "Distribuir Verticalmente",
      "sameWidth": "Mesma Largura",
      "sameHeight": "Mesma Altura",
      "sameAngle": "Mesmo Ângulo",
      "sameSize": "Mesmo Tamanho",
      "replace": "Substituir",
      "replaceAll": "Substituir Todos",
      "styleBrush": "Pincel de formatação",
      "leftArrow": "Início",
      "rightArrow": "Fim"
    }
  },
  "it": {
    "tipsList": {
      "toggleLib": "Mostra Libreria dei Simboli",
      "undo": "Annulla",
      "redo": "Ripeti",
      "format": "Applicatore di Formato",
      "text": "Aggiungi Testo Ctrl+2",
      "textAlign": "Layout, Allineamento, Rapporto di Aspetto",
      "layout": "Posizione, Larghezza, Altezza, Angolo",
      "fixRatio": "Blocca Rapporto di Aspetto",
      "layer": "Livello",
      "fillColor": "Colore di Riempimento",
      "lineColor": "Colore Linea",
      "compose": "Gruppo",
      "search": "Trova",
      "protect": "Bloccato",
      "option": "Impostazioni Speciali",
      "acquiesceStyle": "Stile Linea",
      "theme": "Stile Rapido",
      "connector": "Connettore",
      "layer1": "Porta in Primo Piano",
      "layer2": "Porta in Secondo Piano",
      "layer3": "Porta Avanti",
      "layer4": "Porta Indietro",
      "align01": "Allinea a Sinistra",
      "align02": "Allinea al Centro",
      "align03": "Allinea a Destra",
      "align04": "Allinea in Alto",
      "align05": "Allinea in Mezzo",
      "align06": "Allinea in Basso",
      "align07": "Distribuisci Orizzontalmente",
      "align08": "Distribuisci Verticalmente",
      "sameWidth": "Stessa Larghezza",
      "sameHeight": "Stessa Altezza",
      "sameAngle": "Stesso Angolo",
      "sameSize": "Stessa Dimensione",
      "replace": "Sostituisci",
      "replaceAll": "Sostituisci Tutti",
      "styleBrush": "Pennello stile",
      "leftArrow": "Inizio",
      "rightArrow": "Fine"
    }
  },
  "tw": {
    "tipsList": {
      "toggleLib": "顯示符號庫",
      "undo": "復原",
      "redo": "取消復原",
      "format": "格式刷",
      "text": "添加文本   Ctrl+2",
      "textAlign": "佈局、對齊、等寬高",
      "layout": "位置、寬高、角度",
      "fixRatio": "鎖定縱橫比",
      "layer": "層級",
      "fillColor": "填充顏色",
      "lineColor": "線條顏色",
      "compose": "組合",
      "search": "查找",
      "protect": "鎖定",
      "option": "特殊設置",
      "acquiesceStyle": "線條樣式",
      "theme": "快速樣式",
      "connector": "連結線",
      "layer1": "移至頂部",
      "layer2": "移至底部",
      "layer3": "上移一層",
      "layer4": "下移一層",
      "align01": "左對齊",
      "align02": "居中對齊",
      "align03": "右對齊",
      "align04": "頂部對齊",
      "align05": "居中對齊",
      "align06": "底部對齊",
      "align07": "水平等間距",
      "align08": "垂直等間距",
      "sameWidth": "等寬",
      "sameHeight": "等高",
      "sameAngle": "等角度",
      "sameSize": "等大小",
      "replace": "替換",
      "replaceAll": "替換全部",
      "styleBrush": "格式刷",
      "leftArrow": "起點",
      "rightArrow": "終點"
    }
  }
}
</i18n>
